module.exports = __webpack_public_path__ + "media/images/advisor/img_6_0-fccdad2be12265ffdc894c475a5edd54.png";